import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

const Input = ({ defaultValue, value, onChange, classNameParent, type, className, text, size, icon, append, invalid, iconText, smallColor, maxLength, marginBottom, hidePlaceholder, ...props }) => {
  const propInput = useCallback(() => {
    return defaultValue !== undefined && defaultValue !== null ? { defaultValue } : { value }
  }, [defaultValue, value])

  const hasAddon = !!(icon || iconText || (append && React.Children.count(append) > 0))
  const labelClass = `sp-field-label ${smallColor || ''}`.trim()

  if (type === 'hidden') {
    return <input {...props} {...propInput()} type="hidden" className={'form-control ' + className} />
  }

  return (
    <div className={`${marginBottom}${classNameParent}`.trim()}>
      {text && !hidePlaceholder ? (
        <label className={labelClass} htmlFor={props.id}>
          {text}
        </label>
      ) : null}
      <div className={`sp-field-control input-group input-group-${size} ${hasAddon ? 'sp-field-control--addon' : ''}`.trim()}>
        {icon || iconText ? (
          <div className="input-group-prepend">
            <div className="input-group-text">{icon ? <i className={icon}></i> : iconText}</div>
          </div>
        ) : null}
        {type === 'file' ? (
          <input {...props} {...propInput()} type="file" onChange={onChange} className={'form-control-file ' + className} />
        ) : (
          <input
            {...props}
            {...propInput()}
            onChange={onChange}
            type={type}
            className={'form-control ' + className}
          />
        )}
        {append && React.Children.count(append) > 0 ? (
          <div className="input-group-append">
            {React.Children.toArray(append)}
          </div>
        ) : null}
      </div>
      {invalid ? <div className="invalid-feedback d-block">{invalid}</div> : null}
    </div>
  )
}
Input.defaultProps = {
  size: '',
  classNameParent: 'col-12',
  type: 'text',
  required: false,
  append: [],
  className: '',
  onChange: () => {},
  smallColor: 'text-muted',
  marginBottom: 'mb-4 ',
  hidePlaceholder: false
}
Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['hidden', 'text', 'date', 'time', 'password', 'email', 'number', 'datetime-local', 'file']),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOf(['sm', 'lg', '']),
  classNameParent: PropTypes.string,
  icon: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  pattern: PropTypes.string,
  append: PropTypes.array,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
}
export default Input
